import { useTenantMemberships } from "@/contexts/TenantContext";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function useChangeTenantIfNeeded() {
  const [searchParams] = useSearchParams();
  const { currentTenantMembership, workspaceState, setSelectedTenantMembership } = useTenantMemberships();

  const tenantExternalId = searchParams.get("tenantExternalId");

  useEffect(() => {
    if (!tenantExternalId) {
      return;
    }

    if (tenantExternalId !== currentTenantMembership.tenant.externalId) {
      setSelectedTenantMembership(workspaceState.selectedWorkspace.memberships.find((tm) => tm.tenant.externalId === tenantExternalId)!);
    }
  }, [tenantExternalId, currentTenantMembership, workspaceState]);
}
